import type { LastArrayElement } from 'type-fest';
import type { SchemaMigration } from './schema/types';
import { typeGuard } from '../utils';

export function runMigrations<
  Tdata,
  TMigrations extends Array<SchemaMigration>,
>(
  input: Tdata,
  migrations: TMigrations
): ReturnType<LastArrayElement<TMigrations>['migrator']> {
  if (!typeGuard<{ version: string }>(input, 'version')) {
    throw new Error('missing version');
  }
  if (migrations.length === 0) {
    throw new Error('No migrations');
  }

  // can start at different points in the migration list depending on the version
  // of the input
  const firstMigrationIndex = migrations.findIndex(
    (migration) => migration.fromVersion === input.version
  );

  let data: unknown = input;
  for (const migrationConfig of migrations.slice(firstMigrationIndex)) {
    data = migrationConfig.migrator(data);
  }
  // This will only be reached when we have parsed through all of the migrations
  // typescript is not able to infer this type
  return data as ReturnType<LastArrayElement<typeof migrations>['migrator']>;
}
